var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/electricity_charges.template.html');
var TimePicker = require('views/time_picker.view.ts');

var TheView = GenericView.extend({
    el: '#charges',
    tagName: '',
	template: Handlebars.compile(Template),
	flatPricing: null,
    oldLat: null,
    oldLng: null,
	initialize: function (options) {
        this.render();

/*        $(window).unbind("map:latLngChange").on("map:latLngChange", (event, latLng) => {
            var lat = latLng.lat;
            var lng = latLng.lng;

            var shouldLoadFlatPricing = (self.flatPricing == null && self.oldLat != lat && self.oldLng != lng) || (self.flatPricing != null && self.oldLat != lat && self.oldLng != lng)
            if (shouldLoadFlatPricing)
                self.loadFlatPricing(lat, lng);
        });*/

        GenericView.prototype.storeView(this, "electricity_charges");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        var time_picker_view = new TimePicker();
    },
    events: {
        "input .to-validation input": "validateIt",
        "change input[name='pricing_system']": "checkPricingSystem",
        "click #zoneC": "enableOrDisableFields",
        "click #click": "getAllData",
        "click #collapseDescription": "collapseDescription"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            if ($(element).attr('id') != 'zoneC')
                this.validateSingleField(element);
        },
    300),
    enableOrDisableFields: function() {
        var zoneC_fields = $('table').find('input.zoneC');
        zoneC_fields.push($('table').find('td.time-picker.zoneC'));

        if( $('#zoneC').prop("checked") ) {
            zoneC_fields.each(function(index, element){
                $(element).removeClass("disabled");
            });
        } else {
            zoneC_fields.each(function(index, element){
                $(element).addClass("disabled");
            });
        }
    },
    checkPricingSystem: function() {
        $("#charges").find(".d-none").addClass("to-validation");
        $("#charges").find(".d-none").removeClass("d-none");

        $("#charges ." + $("input[name='pricing_system']:not(:checked)").val()).addClass("d-none").removeClass("to-validation");
    },
    collapseDescription: function(event) {
        var btn = event.currentTarget;
        GenericView.prototype.collapseDescription(btn);
    },
    getAllData: function() {
        var data;

        if ( $("input[name='pricing_system']:checked").val() == "zonal" ) {
            var zones = this.getZonalPricingData();
            var numTariffs =  Object.keys(zones).length;
            data = {
                elpr_country: 2,
                num_tariffs: numTariffs,
                electricityPricing: {
                    VATel: this.convertToFloat($("#vat_tax_zonal"))
                }

            };

            $.each(zones, function(index, value){
                data.electricityPricing[index] = value;
            });
        } else {
            data = {
                elpr_country: 1,
                num_tariffs: null,
                electricityPricing: {
                    Cpr: this.convertToFloat("#Cpr"),
                    Cg: this.convertToFloat("#Cg"),
                    Ct: this.convertToFloat("#Ct"),
                    VATel: this.convertToFloat("#vat_tax_flat")
                }
            };
        }

        return data;
    },
    getZonalPricingData: function(){
        var self = this;
        var zonal_pricing = {};

        var zones = $("input[name=zones]:checked");
        $.each(zones, function(index, value){
            var zone = $(this).val();

            zonal_pricing[zone] = {
                start_tarif: self.convertToInt(self.$el.find(".beginning_time ." +zone +" select")),
                Cpr: self.convertToFloat(self.$el.find(".cpr ." +zone)),
                Cg: self.convertToFloat(self.$el.find(".cg ." +zone)),
                Ct: self.convertToFloat(self.$el.find(".ct ." +zone)),
            }
        });

        return zonal_pricing;
    }
});

module.exports= TheView;